import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { DxContextMenuComponent } from 'devextreme-angular/ui/context-menu';
import { DxSchedulerComponent } from 'devextreme-angular/ui/scheduler';
import moment from 'moment';
import { CalendarEventDialogComponent } from '../calendar-event-dialog/calendar-event-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { alert, confirm } from 'devextreme/ui/dialog';
import { DevExtremeModule } from 'devextreme-angular';
import { SharedModule } from 'app/shared/shared.module';
const appointmentClassName = '.dx-scheduler-appointment';

@Component({
    selector: 'app-event-calendar',
    templateUrl: './event-calendar.component.html',
    styleUrls: ['./event-calendar.component.scss'],
    imports: [CommonModule, DevExtremeModule],
    standalone: true,
})
export class EventCalendarComponent implements OnInit {
    anniversaries: any[];
    birthdays: any[];
    employees: any;
    currentDate = new Date();
    employee: any;
    timeCategories: any;
    schedulerData: any;
    selectedDate = new Date();
    showAsDialog = false;
    processing = true;
    currentViewStart: any;
    specialAccounts: any[];
    target: string = appointmentClassName;
    gray: string = '#C0C0C0';
    blue: string = '#1c84c6';
    red: string = '#FF0000';
    green: string = '#27a400';
    currentView = 'month';

    @ViewChild('scheduler') scheduler: DxSchedulerComponent;
    @ViewChild('appointmentMenu') appointmentMenu: DxContextMenuComponent;
    @ViewChild('cellMenu') cellMenu: DxContextMenuComponent;

    appointmentContextMenuItems = [
        { text: 'Add New', onItemClick: (e) => this.addCalendarEvent(e) },
        { text: 'Edit', onItemClick: (e) => this.addCalendarEvent(e) },
        { text: 'Delete', onItemClick: (e) => this.deleteEvent(e) },

        // { text: 'Go to Today', onItemClick: () => this.showCurrentDate() },
    ];

    cellContextMenuItems = [
        { text: 'Add New', onItemClick: (e) => this.addCalendarEvent(e) },
        { text: 'Go to Today', onItemClick: () => this.showCurrentDate() },
    ];

    contextMenuCellData: any;
    contextMenuAppointmentData: any;
    appointmentData: any;

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService, private appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        const eventTypes = this.uow.lookups.eventTypes;
        await this.getData();
    }

    async getData() {
        // this.specialAccounts = await this.uow.getAccounts();
        let scheduleData = [];

        const calendarEvents = (await this.uow.getCalendarEvents()) as any;
        // console.log(calendarEvents);
        calendarEvents.forEach((event: any) => {
            event.yearDate = moment(event.eventDate).toDate();
            scheduleData.push(event);
        });

        this.schedulerData = scheduleData
            .filter((x) => {
                return !x.deleted;
            })
            .map((x: any) => {
                return {
                    id: x.id,
                    name: x.name,
                    startDate: x.yearDate,
                    color: !x.privateEvent ? this.green : this.red,
                };
            });
    }

    setBackGroundColor(e) {
        e.appointmentElement.style.backgroundColor = e.appointmentData.color;
    }
    toolTip(e) {
        e.cancel = true;
    }

    onCellContextMenu(e) {
        this.contextMenuCellData = e.cellData;
    }
    onAppointmentContextMenu = (e) => {
        this.appointmentData = e.appointmentData;
    };

    onContentReady(e) {
        this.currentViewStart = moment(e.component.getStartViewDate()).format('M/DD/YYYY');
    }

    showCurrentDate() {
        this.currentDate = new Date();
    }

    onContextMenuItemClick = (e) => {
        e.itemData.onItemClick(e);
    };
    onAppointmentMenuItemClick = (e) => {
        // e.itemData.onItemClick = (e) => {return e};
        // console.log('app', e);
        this.contextMenuAppointmentData = e.appointmentData;
    };

    onOptionsChanged(e) {
        // console.log('onOptionsChanged', e);
        if (e.name === 'currentView') this.currentView = e.value;
    }

    async addCalendarEvent(e) {
        // console.log('addnew', e);
        // console.log('conext', this.contextMenuAppointmentData);
        // console.log('appointmentData', this.appointmentData);
        const modalRef = this.modalService.show(CalendarEventDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                eventId: e.itemData.text === 'Add New' ? null : this.appointmentData ? this.appointmentData.id : null,
                eventDate: this.appointmentData ? null : moment(this.contextMenuCellData.startDate).startOf('day').toDate(),
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (!!result && result.success) {
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async deleteEvent(e) {
        const result = await confirm(`Are you sure you want to DELETE the selected event?`, `${this.appInfo.settings.church.toUpperCase()}`);
        if (!result) return;

        const calendarEvent = await this.uow.calendarEvents.byId(this.appointmentData.id) as any;
        if (!calendarEvent) {
            await alert(`Unable to find the selected event`, `${this.appInfo.settings.church.toUpperCase()}`);
            return;
        }
        this.appInfo.pleaseWaitShow();
        calendarEvent.deleted = new Date();
        calendarEvent.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    onAppointmentUpdated = async (e) => {
        const eventId = e.appointmentData?.id;
        const newDate = e.appointmentData?.startDate;
        if (!newDate || !eventId) return;

        this.appInfo.pleaseWaitShow();
        const orderLineDetail = (await this.uow.calendarEvents.byId(eventId)) as any;
        orderLineDetail.eventDate = newDate;
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    };
}
